import React from 'react';
import { useBackground } from 'hooks/useBackground';
import { Header } from 'components/Header';
import { Banner } from 'components/Banner';
import { Description } from 'components/Description';
import { PriceTable } from 'components/PriceTable';
import { ProductButtons } from 'components/ProductButtons';
import { ProductList } from 'components/ProductList';
import { Notice } from 'components/Notice';
import { Footer } from 'components/Footer';
import { useScrollUpdateHash } from 'hooks/useScrollUpdateHash';

export const App = React.memo(() => {
  useBackground();
  useScrollUpdateHash();

  return (
    <React.Fragment>
      <Header />
      <Banner />
      <Description />
      <PriceTable />
      <ProductButtons />
      <ProductList />
      <Notice />
      <Footer />
    </React.Fragment>
  );
});
